import http from "../../backend/http.js";

async function getClient(id) {
  try {
    const response = await http.get(`sales/clients/${id}`);
    return {
      id: response.data.id,
      name: response.data.name,
      legalName: response.data.legalName,
      edrpou: response.data.edrpou,
    };
  } catch (err) {
    throw err;
  }
}

async function updateClient(id, data) {
  try {
    const response = await http.put(`sales/clients/${id}`, data);
    return response;
  } catch (err) {
    throw err;
  }
}

async function createClient(data) {
  try {
    const response = await http.post("sales/clients", data);
    return response;
  } catch (err) {
    throw err;
  }
}

async function getClients(
    page = 1,
    rowsPerPage = 9,
    search = "",
    filter = ""
) {
  try {
    const response = await http.get(
      `sales/clients?page=${page}&pageSize=${rowsPerPage}&searchTerm=${search}${filter}`
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}

async function getClientReferences(
    page = 1,
    rowsPerPage = 9,
    search = "",
    filter = ""
) {
  try {
    const response = await http.get(
      `sales/clients/references?page=${page}&pageSize=${rowsPerPage}&searchTerm=${search}${filter}`
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}

export { getClient, updateClient, getClients, createClient, getClientReferences };